import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const AddNewCard = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 34 22" fill="none" {...props}>
      <rect
        x="0.75"
        y="0.75"
        width="32.5"
        height="20.5"
        rx="3.25"
        fill="#F7F7FA"
        stroke="#77819C"
        strokeWidth="1.5"
      />
      <path d="M17 7L17 15" stroke="#77819C" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M21 11L13 11" stroke="#77819C" strokeWidth="1.5" strokeLinecap="round" />
    </Icon>
  );
};
